<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
})

defineProps<{ label?: string, disabled?: boolean }>()

const model = defineModel<boolean>({ default: false })

const id = useId()
</script>

<template>
  <label :for="id" :class="checkboxVariants.label({ disabled })">
    <input v-bind="$attrs" :id="id" v-model="model" type="checkbox" :disabled="disabled" :class="checkboxVariants.input()">
    <span class="text-small flex gap-px">
      <slot name="label">{{ label }}</slot>
      <span v-if="$attrs.required" class="text-red-500">*</span>
    </span>
  </label>
</template>
